export const LANDINGPAGE = 'home'
export const DEALRISK = 'MLEXDEALRISK'
export const STD = 'MLEXSTD'
export const UNFILTEREDTEXT = '0 filters applied'
export const MAXCONTENTSETLIMIT = 22
export const MAXSEARCHRESULTS = 10000
export const SEARCHPAGERANGE = 9
export const MAXSAVEDSEARCHLIMIT = 150
export const EDITORIALACCESS = 'Editorial Access'
export const CUSTOMERADMINACCESS = 'Customer Admin'
export const CUSTOMERSERVICESACCESS = 'Customer Services'
export const AOISTOIGNORE = [2010, 2011]